import { render, staticRenderFns } from "./FranchiseProfile.vue?vue&type=template&id=23621909&"
import script from "./FranchiseProfile.vue?vue&type=script&lang=js&"
export * from "./FranchiseProfile.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseProfile.vue?vue&type=style&index=0&id=23621909&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports